import ServiceAccordion from "./service-accordion";
import { Box, Typography } from "@mui/material";

type Props = {
  services: any[];
  tax?: number;
  total?: number;
};

const ServiceList: React.FC<Props> = ({ services = [], tax = 0, total = 0 }) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginBottom: "12px",
        }}
      >
        <h3 className="service-title" style={{ margin: 0 }}>
          Service
        </h3>
        <Typography
          sx={{
            color: "#6B6B6B",
            fontSize: "12px",
            lineHeight: "32px",
            fontWeight: 400,
          }}
        >
          *Only Immediate Need services are billed. For Preneed services,
          coordinate payment with the customer
        </Typography>
      </Box>

      {services.map((service, index) => (
        <ServiceAccordion
          key={service.serviceId || index}
          service={service}
        />
      ))}

      <div className="summary-section">
        <div className="summary-row">
          <span>Taxes</span>
          <span>${tax}</span>
        </div>

        <div className="summary-row grand-total">
          <span>Total Amount</span>
          <span>${total}</span>
        </div>
      </div>
    </>
  );
};

export default ServiceList;